module.exports = __webpack_public_path__ + "assets/img/4.f6b4b46b.png";